import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3974a0b3 = () => interopDefault(import('../../../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _484494f6 = () => interopDefault(import('../../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _3dd41f1f = () => interopDefault(import('../../../pages/account/billing.vue' /* webpackChunkName: "pages/account/billing" */))
const _4139d1a4 = () => interopDefault(import('../../../pages/account/refer.vue' /* webpackChunkName: "pages/account/refer" */))
const _3d448a69 = () => interopDefault(import('../../../pages/account/team.vue' /* webpackChunkName: "pages/account/team" */))
const _7b3418ef = () => interopDefault(import('../../../pages/community-list/index.vue' /* webpackChunkName: "pages/community-list/index" */))
const _0c636155 = () => interopDefault(import('../../../pages/confirm-email.vue' /* webpackChunkName: "pages/confirm-email" */))
const _159e6aaf = () => interopDefault(import('../../../pages/confirm-signup.vue' /* webpackChunkName: "pages/confirm-signup" */))
const _0de82c25 = () => interopDefault(import('../../../pages/contact-sales.vue' /* webpackChunkName: "pages/contact-sales" */))
const _45146356 = () => interopDefault(import('../../../pages/deck/index.vue' /* webpackChunkName: "pages/deck/index" */))
const _462bcc70 = () => interopDefault(import('../../../pages/decks.vue' /* webpackChunkName: "pages/decks" */))
const _69a93ef3 = () => interopDefault(import('../../../pages/decks/index.vue' /* webpackChunkName: "pages/decks/index" */))
const _2dd42ccc = () => interopDefault(import('../../../pages/decks/team.vue' /* webpackChunkName: "pages/decks/team" */))
const _4c3ebca3 = () => interopDefault(import('../../../pages/event/index.vue' /* webpackChunkName: "pages/event/index" */))
const _47ca0f46 = () => interopDefault(import('../../../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _51707c52 = () => interopDefault(import('../../../pages/go.vue' /* webpackChunkName: "pages/go" */))
const _23774b9d = () => interopDefault(import('../../../pages/landing.vue' /* webpackChunkName: "pages/landing" */))
const _71f86922 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _5b4140f6 = () => interopDefault(import('../../../pages/print/index.vue' /* webpackChunkName: "pages/print/index" */))
const _480a8088 = () => interopDefault(import('../../../pages/recap/index.vue' /* webpackChunkName: "pages/recap/index" */))
const _1141f4c4 = () => interopDefault(import('../../../pages/report.vue' /* webpackChunkName: "pages/report" */))
const _8bb8657a = () => interopDefault(import('../../../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _17dd903f = () => interopDefault(import('../../../pages/templates.vue' /* webpackChunkName: "pages/templates" */))
const _d032a8fc = () => interopDefault(import('../../../pages/templates/index.vue' /* webpackChunkName: "pages/templates/index" */))
const _78afafdb = () => interopDefault(import('../../../pages/templates/_tag.vue' /* webpackChunkName: "pages/templates/_tag" */))
const _6235e27c = () => interopDefault(import('../../../pages/test.vue' /* webpackChunkName: "pages/test" */))
const _18e6894e = () => interopDefault(import('../../../pages/admin/users.vue' /* webpackChunkName: "pages/admin/users" */))
const _392421c5 = () => interopDefault(import('../../../pages/analytics/users.vue' /* webpackChunkName: "pages/analytics/users" */))
const _5acfb40c = () => interopDefault(import('../../../pages/embed/auth-state.vue' /* webpackChunkName: "pages/embed/auth-state" */))
const _452f3a3a = () => interopDefault(import('../../../pages/embed/decks.vue' /* webpackChunkName: "pages/embed/decks" */))
const _a2db35d4 = () => interopDefault(import('../../../pages/embed/pricing.vue' /* webpackChunkName: "pages/embed/pricing" */))
const _129c8445 = () => interopDefault(import('../../../pages/embed/sales-form.vue' /* webpackChunkName: "pages/embed/sales-form" */))
const _074606da = () => interopDefault(import('../../../pages/events/stats.vue' /* webpackChunkName: "pages/events/stats" */))
const _67a1a69c = () => interopDefault(import('../../../pages/uscc/2024-local-uscc-import.vue' /* webpackChunkName: "pages/uscc/2024-local-uscc-import" */))
const _0cd37fc2 = () => interopDefault(import('../../../pages/uscc/2024-state-uscc-import.vue' /* webpackChunkName: "pages/uscc/2024-state-uscc-import" */))
const _5175ccca = () => interopDefault(import('../../../pages/uscc/2025-import.vue' /* webpackChunkName: "pages/uscc/2025-import" */))
const _101983d7 = () => interopDefault(import('../../../pages/uscc/all-chambers.js' /* webpackChunkName: "pages/uscc/all-chambers" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _53ef433e = () => interopDefault(import('../../../pages/deck/_id.vue' /* webpackChunkName: "pages/deck/_id" */))
const _924678c2 = () => interopDefault(import('../../../pages/edit/_id.vue' /* webpackChunkName: "pages/edit/_id" */))
const _18898bcb = () => interopDefault(import('../../../pages/event/_id.vue' /* webpackChunkName: "pages/event/_id" */))
const _82b86586 = () => interopDefault(import('../../../pages/host/_id.vue' /* webpackChunkName: "pages/host/_id" */))
const _ee0a290e = () => interopDefault(import('../../../pages/preview/_id.vue' /* webpackChunkName: "pages/preview/_id" */))
const _e611ee44 = () => interopDefault(import('../../../pages/print/_id.vue' /* webpackChunkName: "pages/print/_id" */))
const _44ec3f60 = () => interopDefault(import('../../../pages/recap/_uuid.vue' /* webpackChunkName: "pages/recap/_uuid" */))

const _921497a2 = () => interopDefault(import('~/pages/login.vue' /* webpackChunkName: "" */))
const _b1cb8de0 = () => interopDefault(import('~/pages/recap/_uuid.vue' /* webpackChunkName: "" */))
const _77d9148b = () => interopDefault(import('~/pages/event/_id.vue' /* webpackChunkName: "" */))
const _79354b92 = () => interopDefault(import('~/pages/go.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _3974a0b3,
    children: [{
      path: "",
      component: _484494f6,
      name: "account"
    }, {
      path: "billing",
      component: _3dd41f1f,
      name: "account-billing"
    }, {
      path: "refer",
      component: _4139d1a4,
      name: "account-refer"
    }, {
      path: "team",
      component: _3d448a69,
      name: "account-team"
    }]
  }, {
    path: "/community-list",
    component: _7b3418ef,
    name: "community-list"
  }, {
    path: "/confirm-email",
    component: _0c636155,
    name: "confirm-email"
  }, {
    path: "/confirm-signup",
    component: _159e6aaf,
    name: "confirm-signup"
  }, {
    path: "/contact-sales",
    component: _0de82c25,
    name: "contact-sales"
  }, {
    path: "/deck",
    component: _45146356,
    name: "deck"
  }, {
    path: "/decks",
    component: _462bcc70,
    children: [{
      path: "",
      component: _69a93ef3,
      name: "decks"
    }, {
      path: "team",
      component: _2dd42ccc,
      name: "decks-team"
    }]
  }, {
    path: "/event",
    component: _4c3ebca3,
    name: "event"
  }, {
    path: "/events",
    component: _47ca0f46,
    name: "events"
  }, {
    path: "/go",
    component: _51707c52,
    name: "go"
  }, {
    path: "/landing",
    component: _23774b9d,
    name: "landing"
  }, {
    path: "/login",
    component: _71f86922,
    name: "login"
  }, {
    path: "/print",
    component: _5b4140f6,
    name: "print"
  }, {
    path: "/recap",
    component: _480a8088,
    name: "recap"
  }, {
    path: "/report",
    component: _1141f4c4,
    name: "report"
  }, {
    path: "/reset-password",
    component: _8bb8657a,
    name: "reset-password"
  }, {
    path: "/templates",
    component: _17dd903f,
    children: [{
      path: "",
      component: _d032a8fc,
      name: "templates"
    }, {
      path: ":tag",
      component: _78afafdb,
      name: "templates-tag"
    }]
  }, {
    path: "/test",
    component: _6235e27c,
    name: "test"
  }, {
    path: "/admin/users",
    component: _18e6894e,
    name: "admin-users"
  }, {
    path: "/analytics/users",
    component: _392421c5,
    name: "analytics-users"
  }, {
    path: "/embed/auth-state",
    component: _5acfb40c,
    name: "embed-auth-state"
  }, {
    path: "/embed/decks",
    component: _452f3a3a,
    name: "embed-decks"
  }, {
    path: "/embed/pricing",
    component: _a2db35d4,
    name: "embed-pricing"
  }, {
    path: "/embed/sales-form",
    component: _129c8445,
    name: "embed-sales-form"
  }, {
    path: "/events/stats",
    component: _074606da,
    name: "events-stats"
  }, {
    path: "/uscc/2024-local-uscc-import",
    component: _67a1a69c,
    name: "uscc-2024-local-uscc-import"
  }, {
    path: "/uscc/2024-state-uscc-import",
    component: _0cd37fc2,
    name: "uscc-2024-state-uscc-import"
  }, {
    path: "/uscc/2025-import",
    component: _5175ccca,
    name: "uscc-2025-import"
  }, {
    path: "/uscc/all-chambers",
    component: _101983d7,
    name: "uscc-all-chambers"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }, {
    path: "/deck/:id",
    component: _53ef433e,
    name: "deck-id"
  }, {
    path: "/edit/:id?",
    component: _924678c2,
    name: "edit-id"
  }, {
    path: "/event/:id",
    component: _18898bcb,
    name: "event-id"
  }, {
    path: "/host/:id?",
    component: _82b86586,
    name: "host-id"
  }, {
    path: "/preview/:id?",
    component: _ee0a290e,
    name: "preview-id"
  }, {
    path: "/print/:id",
    component: _e611ee44,
    name: "print-id"
  }, {
    path: "/recap/:uuid",
    component: _44ec3f60,
    name: "recap-uuid"
  }, {
    path: "/popular",
    redirect: "/templates"
  }, {
    path: "/login",
    component: _921497a2,
    alias: "/register"
  }, {
    path: "/screencap/:uuid/:slide/:step",
    component: _b1cb8de0,
    alias: "/recap/:uuid",
    name: "screenshot"
  }, {
    path: "/spectate/:id",
    component: _77d9148b,
    alias: "/event/:id",
    name: "spectate"
  }, {
    path: "/:code([a-zA-Z0-9]{3,10})",
    component: _79354b92,
    alias: "/go",
    name: "joinEvent"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
